import { render } from "./TheChip.vue?vue&type=template&id=ed93020c"
import script from "./TheChip.vue?vue&type=script&lang=js"
export * from "./TheChip.vue?vue&type=script&lang=js"

import "./TheChip.vue?vue&type=style&index=0&id=ed93020c&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__